export default __webpack_public_path__ + "static/media/free-linkedin-icon-130-thumb.c131142b.png";